import { render } from "./App.vue?vue&type=template&id=72aefa6a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=72aefa6a&lang=scss"

import exportComponent from "/Users/malina/mySpace/v-art/protocol/3d-viewer/viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__